










import { Component, Vue } from 'vue-property-decorator';
import DefaultLayout from '@/layouts/DefaultLayout.vue';
import PerformedWorkDetails from '@/components/PerformedWorkDetails.vue';

@Component({
    components: {
        'default-layout': DefaultLayout,
        'performedWork-details': PerformedWorkDetails
    }
})
export default class HomeView extends Vue {
}
